import { Space } from 'component/Space'
import { observer } from 'mobx-react-lite'
import { Shape } from 'page/ProfileScreen/BasicSelfiesPanel/shape/Shape'
import { store } from 'store/store'
import { ShapeType } from 'type/Identity'

const MALE_SHAPES: ShapeType[] = [ShapeType.INVERTED_TRIANGLE, ShapeType.OVAL, ShapeType.RECTANGLE, ShapeType.TRIANGLE]
const FEMALE_SHAPES: ShapeType[] = [ShapeType.APPLE, ShapeType.HOURGLASS, ShapeType.PEAR, ShapeType.RECTANGLE, ShapeType.TRIANGLE]

export const ShapeSelect = observer(() => {
  const basic = store.profile.basic
  const gender = basic.gender
  const shapes = gender === 'male' ? MALE_SHAPES : FEMALE_SHAPES

  return <Space gap={12}>
    {shapes.map((shape) => <Shape key={shape} shape={shape} />)}
  </Space>
})
